// Entry point built into a single embed.js bundle. Tenants drop one
// <script src="https://app.chatmerce.eu/embed.js"></script> on their
// page; that registers the <chatmerce-chat> custom element. They then
// add a <chatmerce-chat tenant="acme"></chatmerce-chat> wherever they
// want the floating launcher to live.

import { ChatmerceChat } from "./chatmerce-chat";

const TAG = "chatmerce-chat";
if (!customElements.get(TAG)) {
  customElements.define(TAG, ChatmerceChat);
}

// Expose the class on globalThis so host pages can subclass / introspect
// if they need to. Not part of the public API — but a single name on a
// well-namespaced object is a low-risk affordance.
(globalThis as unknown as { Chatmerce?: unknown }).Chatmerce = {
  Chat: ChatmerceChat,
  version: "0.1.0",
};
